
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/[article_id]",
      function () {
        return require("private-next-pages/article/[article_id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/[article_id]"])
      });
    }
  